const PaperIcon = () => (
  <svg
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.09186 8.02835C8.09186 3.78964 11.5479 0.354248 15.812 0.354248L29.4985 0.354249C33.969 0.35425 37.6142 3.96057 37.6142 8.40437L37.6142 26.8639C37.6142 31.1026 34.1582 34.538 29.894 34.538H16.2075C11.737 34.538 8.09186 30.9317 8.09186 26.4879L8.09186 8.02835Z"
      fill="url(#paint0_linear_412_9704)"
    />
    <g filter="url(#filter0_bi_412_9704)">
      <path
        d="M8.07739 3.46191L20.8448 3.46191L29.8452 12.9915L29.8452 29.9741C29.8452 34.2133 26.3891 37.6491 22.125 37.6491H8.43847C3.968 37.6491 0.322845 34.0423 0.322845 29.598L0.322845 11.1711C0.322845 6.93191 3.79606 3.46191 8.07739 3.46191Z"
        fill="#4AB14C"
        fillOpacity="0.5"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.9535 16.873H9.14185C8.4369 16.873 7.85229 17.4542 7.85229 18.1551C7.85229 18.8559 8.4369 19.42 9.14185 19.42H14.9535C15.6584 19.42 16.243 18.8559 16.243 18.1551C16.243 17.4542 15.6584 16.873 14.9535 16.873ZM9.14239 27.9661H18.496C19.2009 27.9661 19.7856 27.3849 19.7856 26.684C19.7856 25.9832 19.2009 25.4191 18.496 25.4191H9.14239C8.43743 25.4191 7.85283 25.9832 7.85283 26.684C7.85283 27.3849 8.43743 27.9661 9.14239 27.9661Z"
      fill="white"
      fillOpacity="0.9"
    />
    <path
      d="M22.4363 15.0225C23.6347 15.0344 25.3008 15.0396 26.7142 15.0344C27.438 15.0327 27.806 14.1729 27.3039 13.655C25.4882 11.7781 22.2402 8.41921 20.3816 6.49789C19.8675 5.96628 18.9682 6.33208 18.9682 7.06882V11.5747C18.9682 13.4652 20.5346 15.0225 22.4363 15.0225"
      fill="white"
      fillOpacity="0.9"
    />
    <defs>
      <filter
        id="filter0_bi_412_9704"
        x="-3.67715"
        y="-0.538086"
        width="37.5223"
        height="42.1873"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_412_9704"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_412_9704"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.2" dy="0.1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
        <feBlend mode="normal" in2="shape" result="effect2_innerShadow_412_9704" />
      </filter>
      <linearGradient
        id="paint0_linear_412_9704"
        x1="44.3504"
        y1="60.7455"
        x2="-6.33256"
        y2="54.7268"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#055532" />
        <stop offset="0.546875" stopColor="#4FB84E" />
        <stop offset="1" stopColor="#83D660" />
      </linearGradient>
    </defs>
  </svg>
);

export default PaperIcon;
